import styled from 'styled-components';

export const Button = styled.button`
  padding: 18px;
  max-width: 250px;
  border-radius: 14px;
  border: none;
  cursor: pointer;
  font-size: 22px;
  text-transform: uppercase;
  background: #faef00;
  color: #000;
  font-weight: 800;
  position: absolute;
  left: 10%;
  top: 70%;
  transform: translateY(-50%);
  line-height: 1.2;

  @media (max-width: 1200px) {
    left: 5%;
    font-size: 18px;
    padding: 14px;
    max-width: 200px;
  }

  @media (max-width: 768px) {
    position: static;
    transform: none;
    margin-bottom: 1rem;
    font-size: 16px;
    padding: 12px;
    max-width: 180px;
  }

  :focus {
    outline: none;
  }
`;

export const Logo = styled.img`
  width: 33%;
`;

export const Modal = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 620,
  maxHeight: '90vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '12px',
  overflow: 'hidden',

  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1rem',
};

export const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 2rem;
`;

export const BackButton = styled.button`
  padding: 16px 32px;
  max-width: 220px;
  border-radius: 14px;
  border: none;
  cursor: pointer;
  font-size: 28px;
  text-transform: uppercase;
  background: transparent;
  border: 1px solid #000;
  color: #000;
  font-weight: 800;
  margin-top: 2.5rem;

  :focus {
    outline: none;
  }
`;

export const SubmitButton = styled.button`
  padding: 16px 48px;
  max-width: 220px;
  border-radius: 14px;
  border: none;
  cursor: pointer;
  font-size: 28px;
  text-transform: uppercase;
  background: #faef00;
  border: 1px solid #000;
  color: #000;
  font-weight: 800;
  margin-top: 2.5rem;

  :focus {
    outline: none;
  }
`;
